import { useSMSStatusChangeAction } from '@actions/SMSStatusChangeAction';

export const useConfirmOptOutDialogController = (closeDialog: () => void) => {
  const { mutateAsync: action } = useSMSStatusChangeAction();
  const optOutSMS = async () => {
    await action('OPT-OUT');
    closeDialog();
  };

  const optInSMS = async () => {
    await action('OPT-IN');
    closeDialog();
  };
  return {
    optOutSMS,
    optInSMS,
  };
};
